import { render, staticRenderFns } from "./SaleOrderDetail.vue?vue&type=template&id=468a32b5&scoped=true"
import script from "./SaleOrderDetail.vue?vue&type=script&lang=js"
export * from "./SaleOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderDetail.vue?vue&type=style&index=0&id=468a32b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a32b5",
  null
  
)

export default component.exports